import request from "../util/request";
import SERVER_URL from "../util/seaver";
import { exportsFile } from "../util/exports";
// 批次
function batchSel (reqData) {
  const reqUrl =
    SERVER_URL + "/batch/sel";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function batchAdd (reqData) {
  const reqUrl =
    SERVER_URL + "/batch/add";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function batchDel (reqData) {
  const reqUrl =
    SERVER_URL + "/batch/del";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function batchMod (reqData) {
  const reqUrl =
    SERVER_URL + "/batch/mod";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function batchStart (reqData) {
  const reqUrl =
    SERVER_URL + "/batch/start";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function batchComplete (reqData) {
  const reqUrl =
    SERVER_URL + "/batch/complete";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
//工序
function processSel (reqData) {
  const reqUrl =
    SERVER_URL + "/process/sel";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function processAdd (reqData) {
  const reqUrl =
    SERVER_URL + "/process/add";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function processDel (reqData) {
  const reqUrl =
    SERVER_URL + "/process/del";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function processMod (reqData) {
  const reqUrl =
    SERVER_URL + "/process/mod";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function batchCheck (reqData) {
  const reqUrl =
    SERVER_URL + "/batch/check";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
//工序进度
function batchProcess (reqData) {
  const reqUrl =
    SERVER_URL + "/workRecord/batchProcess";
  return request({
    url: reqUrl,
    method: "POST",
    data: reqData
  });
}
function processExport (reqData, name) {
  const reqUrl =
    SERVER_URL + "/process/export?token=" + localStorage.getItem("token");
  exportsFile(reqUrl, reqData, name)
}


export {
  batchSel,
  batchAdd,
  batchDel,
  batchMod,
  batchStart,
  batchComplete,
  processSel,
  processAdd,
  processDel,
  processMod,
  batchCheck,
  batchProcess,
  processExport
};
